import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import Disclosure from 'components/Disclosure';
var PlainZipFileModal = function PlainZipFileModal(_ref) {
  var fileName = _ref.fileName,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('modal_upload_plain_zip_title'),
    subtitle: fileName,
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "s"
    }, t('modal_upload_plain_zip_message'), /*#__PURE__*/React.createElement(Disclosure.Provider, null, /*#__PURE__*/React.createElement(Disclosure.Toggle, null, t('modal_upload_plain_zip_disclosure_toggle')), /*#__PURE__*/React.createElement(Disclosure.Hidden, null, /*#__PURE__*/React.createElement(Stack, {
      spacing: "s",
      mt: "s",
      mx: "s"
    }, /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "modal_upload_plain_zip_info_microsite"
    }), /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "modal_upload_plain_zip_info_scorm"
    }))))),
    buttons: [{
      label: t('actions_upload_new_file'),
      onClick: onCancel
    }, {
      label: t('actions_upload_as_zip'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onCancel
  });
};
export default PlainZipFileModal;